module.exports = __webpack_public_path__ + "img/right-more-4.3b5a53a6.png";